import { useEffect } from "react";
import Navbar from "../components/Navbar/Navbar";
import "./LegalPage.css";

const LAST_UPDATED = "August 2025";
const EMAIL = "info@forge.ngo";

export default function RefundPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="legal">
        <div className="legal__hero">
          <div className="container-fg container-2xxl">
            <p className="legal__eyebrow">Legal</p>
            <h1 className="legal__title">Refund Policy</h1>
            <p className="legal__meta">Last updated: {LAST_UPDATED}</p>
          </div>
        </div>

        <div className="legal__body container-fg container-2xxl">
          <div className="legal__intro">
            <p>FORGE NGO provides its retreats entirely free of charge to eligible participants. This Refund Policy applies exclusively to voluntary donations made to FORGE NGO.</p>
          </div>

          <section className="legal__section">
            <h2>1. Our Retreats Are Free</h2>
            <p>Retreat participants are never charged for participation, accommodation, meals, or programme activities. There is nothing to refund for retreat attendance.</p>
          </section>

          <section className="legal__section">
            <h2>2. Donations</h2>
            <p>FORGE NGO appreciates every donation. As a registered 501(c)(3) public charity, all donations are tax-deductible to the extent permitted by law.</p>
            <h3>Refund eligibility</h3>
            <ul>
              <li>
                <strong>Within 30 days</strong> — Donations made in error or through technical issues may be refunded within 30 days of the transaction date, upon request and at our sole discretion.
              </li>
              <li>
                <strong>After 30 days</strong> — We are generally unable to refund donations after 30 days, as funds are committed to programme operations.
              </li>
              <li>
                <strong>Recurring donations</strong> — You may cancel a recurring donation at any time by contacting us. Cancellation takes effect for the next scheduled payment; amounts already
                processed are non-refundable.
              </li>
            </ul>
          </section>

          <section className="legal__section">
            <h2>3. How to Request a Refund</h2>
            <p>
              To request a refund, please email us at <a href={`mailto:${EMAIL}`}>{EMAIL}</a> with:
            </p>
            <ul>
              <li>Your full name and email address used for the donation.</li>
              <li>The donation amount and approximate date.</li>
              <li>The reason for your request.</li>
            </ul>
            <p>We will respond within 5 business days. Approved refunds are processed to the original payment method within 7–10 business days.</p>
          </section>

          <section className="legal__section">
            <h2>4. Fraudulent Transactions</h2>
            <p>
              If you believe an unauthorised charge has been made, please contact your bank or card issuer immediately, and notify us at <a href={`mailto:${EMAIL}`}>{EMAIL}</a>. We take financial
              security seriously and will cooperate fully with any investigation.
            </p>
          </section>

          <section className="legal__section">
            <h2>5. Tax Receipts</h2>
            <p>
              A tax receipt is automatically emailed to you when your donation is processed. If you require a duplicate receipt or a correction, please contact us at{" "}
              <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.
            </p>
          </section>

          <section className="legal__section">
            <h2>6. Contact</h2>
            <p>
              For all refund requests and questions:
              <br />
              <strong>FORGE NGO</strong>
              <br />
              5203 Preserve Park Dr, Spring, TX 77389
              <br />
              <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            </p>
          </section>
        </div>
      </div>
    </>
  );
}
